import colors from 'basic-ui-lib/constants/colors';
import { IContentItem } from 'modules/channel/interfaces/api';
import styled from 'styled-components';
import { renderMedia } from '../MainZone';

interface TwoZoneProps {
  value?: IContentItem[];
  activeZone?: string;
  onSelectZone?: (zone: string) => void;
  border?: number;
  gap?: number;
}
const TwoZone = ({ value, activeZone, onSelectZone, border, gap }: TwoZoneProps) => {
  const zoneValue = value?.find(item => item.zone === 'LEFT');
  const ticketValue = value?.find(item => item.zone === 'RIGHT');
  
  return  (
    <TwoZoneIllustration $border={border} $gap={gap}>
      <MainZone $border={border} $active={activeZone === 'LEFT'} onClick={() => onSelectZone?.('LEFT')}>
        {renderMedia(zoneValue, border)}
      </MainZone>
      <Ticket $border={border} $active={activeZone === 'RIGHT'} onClick={() => onSelectZone?.('RIGHT')}>
        {renderMedia(ticketValue, border)}
      </Ticket>
    </TwoZoneIllustration>
  );
};

export default TwoZone;

const TwoZoneIllustration = styled.div<{$border?: number; $gap?: number}>`
  width: 100%;
  height: 100%;
  min-width: 48px;
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  background-color: ${colors.neutral.text[3]};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: ${({ $gap }) => ($gap ? `${$gap}px` : '1px')};
`;

const MainZone = styled.div<{$border?: number; $active?: boolean}>`
  width: 80%;
  height: 90%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;

const Ticket = styled.div<{$border?: number; $active?: boolean}>`
  width: 20%;
  height: 90%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;